import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useLocation, useParams } from "react-router-dom";
import config from "../../config/config";
import moment from "moment";
import { event } from "jquery";
import { set } from "react-hook-form";
import jsPDF from "jspdf";
import CryptoJS from "crypto-js";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../DatePicker/CommonDatePicker";
import CurrencySymbols from "../../common/CurrencySymbol";
import { AppContext } from "../../context/AppContext";
import {
  CUSTOM_SELECT_DROPDOWN_RECEIPT_STYLE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../common/Constant";
import ReportDate from "../Reports/ReportDate";
import html2pdf from "html2pdf.js";
import Reportcurrencysymbols from "../../common/Reportcurrencysymbols";

const PurchaseStatement = ({ customerid, ecomuser }) => {
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    currencySymbolLocation,
  } = useContext(AppContext);
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const Location = localStorage.getItem("Location");

  console.log(customerid, ecomuser, "0147");

  let location = useLocation();

  console.log(location.pathname.split("/")[1], "pageloaction");

  const ComponentURl = location.pathname.split("/")[1] === "customerstatement";

  console.log(ComponentURl, "ComponentURl");
  // console.log(paramObject, "jjjjjjjjjjjj");

  //   const decrypted2 = CryptoJS.AES.decrypt( paramObject?.id, config.portalSendIdKey);
  //  const decryptedData = decrypted2.toString(CryptoJS.enc.Utf8);
  //     const parseddata = decryptedData ? JSON.parse(decryptedData) : null;

  //     console.log(parseddata, "parse customer id")
  const [subCompany, setsubCompany] = useState([]);
  const [SelectedSubCompany, setSelectedSubCompany] = useState();
  const [companyData, setCompanyData] = useState();
  const [customerDetails, setCustomerDetails] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [dateFilter, setDateFilter] = useState();
  const [selectReport, setSelectReport] = useState(1);
  const [selectedDate, setSelectedDate] = useState([]);
  // const [beginningDate, setBeginningDate] = useState( moment().startOf("month").format("YYYY-MM-DD"));
  // const [finalDate, setFinalDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const [beginningDate, setBeginningDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const columns = [
    {
      name: "Date",
      width: "160px",
      selector: (row) =>
        moment(row["Date"]).format(`${dateFormate.toUpperCase()}`),
      sortable: false,
    },
    {
      name: "Details",
      width: "420px",
      selector: (row) => {
        return <div style={{ width: "320px" }}>{row["Details"]}</div>;
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "60px",
          }}
        >
          Credit
        </div>
      ),
      selector: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {CurrencySymbols(
              Number(row.Payments),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* {`$${Number(row?.Payments).toLocaleString('en-US' , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "60px",
          }}
        >
          Debit
        </div>
      ),
      selector: (row) => {
        return (
          <div className="text-right" style={{ width: "108px" }}>
            {CurrencySymbols(
              Number(row.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* {`$${Number(row?.Amount).toLocaleString('en-US' , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "33px",
          }}
        >
          Balance
        </div>
      ),
      width: "130px",
      selector: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {CurrencySymbols(
              Number(row.Balance),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* {`$${Number(row?.Balance).toLocaleString('en-US' , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
          </div>
        );
      },
      sortable: true,
    },
  ];
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });
  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 2 },
    { label: "Last Year", value: 3 },
    { label: "This Month", value: 4 },
    { label: "This Week", value: 5 },
    { label: "This Year", value: 6 },
    { label: "Last Month", value: 8 },
    { label: "Custom", value: 7 },
  ];

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setBeginningDate("");
      setFinalDate("");
    }
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    // if (selectReport != 2){
    setBeginningDate(payload);
    setFinalDate(enddate2);
    // }

    console.log("enddate =>", enddate2);
  };

  useEffect(() => {
    if (selectReport != 2) {
      customerStatementAPI();
    }
  }, [beginningDate, finalDate]);

  //Date

  //Today
  // let today = moment().format("YYYY-MM-DD");
  // //Week
  // const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  // const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  // //This Month
  // const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  // const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  // //Last Month
  // const startOfLastMonth = moment()
  //   .subtract(1, "month")
  //   .startOf("month")
  //   .format("YYYY-MM-DD");
  // const endOfLastMonth = moment()
  //   .subtract(1, "month")
  //   .endOf("month")
  //   .format("YYYY-MM-DD");
  // //This Year
  // const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  // const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  // //Last Year
  // const startOfLastYear = moment()
  //   .subtract(1, "year")
  //   .startOf("year")
  //   .format("YYYY-MM-DD");
  // const endOfLastYear = moment()
  //   .subtract(1, "year")
  //   .endOf("year")
  //   .format("YYYY-MM-DD");

  // const handleQuickBookChange = (event) => {
  //   console.log(event, "eventtt");
  //   setDateFilter(event?.value);
  //   if (event?.value !== 7) {
  //     setStartDate(moment().format("YYYY-MM-DD"));
  //     setEndDate(moment().format("YYYY-MM-DD"));
  //   }
  //   if (event?.value == 2) {
  //     setBeginningDate(today);
  //     setFinalDate(today);
  //   } else if (event?.value == 5) {
  //     setBeginningDate(startOfWeek);
  //     setFinalDate(endOfWeek);
  //   } else if (event?.value == 4) {
  //     setBeginningDate(startOfMonth);
  //     setFinalDate(endOfMonth);
  //   } else if (event?.value == 8) {
  //     setBeginningDate(startOfLastMonth);
  //     setFinalDate(endOfLastMonth);
  //   } else if (event?.value == 6) {
  //     setBeginningDate(startOfYear);
  //     setFinalDate(endOfYear);
  //   } else if (event?.value == 3) {
  //     setBeginningDate(startOfLastYear);
  //     setFinalDate(endOfLastYear);
  //   } else if (event?.value == 1) {
  //     setBeginningDate("");
  //     setFinalDate("");
  //   }
  // };

  // const handleDate = (event) => {
  //   console.log(event?.target?.value, "eventisss92");
  //   setStartDate(event?.target?.value);
  //   setBeginningDate(event?.target?.value);
  // };

  // const handleDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     // const datetime =
  //     //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     // const settime = moment(datetime).format("YYYY-MM-DD");
  //     // console.log(settime, "settime");
  //     setStartDate(selectedDate);
  //     setBeginningDate(selectedDate);
  //   }
  // };

  // const handleEndDate = (event) => {
  //   setEndDate(event?.target?.value);
  //   setFinalDate(event?.target?.value);
  // };

  const handleEndDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setEndDate(selectedDate);
      setFinalDate(selectedDate);
    }
  };

  //Serach Button
  const handleSearch = () => {
    // console.log(startDate, endDate, "1555");
    customerStatementAPI(beginningDate, finalDate);
  };

  // const dateFilterData =
  //   dateFilter == 2 ? (
  //     <p>
  //       {moment(today).format(`${dateFormate.toUpperCase()}`) +
  //         " To " +
  //         moment(today).format(`${dateFormate.toUpperCase()}`)}
  //     </p>
  //   ) : dateFilter === 5 ? (
  //     <p>
  //       {moment(startOfWeek).format(`${dateFormate.toUpperCase()}`) +
  //         " To " +
  //         moment(endOfWeek).format(`${dateFormate.toUpperCase()}`)}
  //     </p>
  //   ) : dateFilter === 4 ? (
  //     <p>
  //       {moment(startOfMonth).format(`${dateFormate.toUpperCase()}`) +
  //         " To " +
  //         moment(endOfMonth).format(`${dateFormate.toUpperCase()}`)}
  //     </p>
  //   ) : dateFilter === 8 ? (
  //     <p>
  //       {moment(startOfLastMonth).format(`${dateFormate.toUpperCase()}`) +
  //         " To " +
  //         moment(endOfLastMonth).format(`${dateFormate.toUpperCase()}`)}
  //     </p>
  //   ) : dateFilter === 6 ? (
  //     <p>
  //       {moment(startOfYear).format(`${dateFormate.toUpperCase()}`) +
  //         " To " +
  //         moment(endOfYear).format(`${dateFormate.toUpperCase()}`)}
  //     </p>
  //   ) : dateFilter === 3 ? (
  //     <p>
  //       {moment(startOfLastYear).format(`${dateFormate.toUpperCase()}`) +
  //         " To " +
  //         moment(endOfLastYear).format(`${dateFormate.toUpperCase()}`)}
  //     </p>
  //   ) : dateFilter === 7 ? (
  //     startDate === undefined ? (
  //       <p>
  //         {moment(today).format(`${dateFormate.toUpperCase()}`) +
  //           " To " +
  //           moment(today).format(`${dateFormate.toUpperCase()}`)}
  //       </p>
  //     ) : (
  //       <p>
  //         {moment(startDate).format(`${dateFormate.toUpperCase()}`) +
  //           " To " +
  //           moment(endDate).format(`${dateFormate.toUpperCase()}`)}
  //       </p>
  //     )
  //   ) : (
  //     <p>All Data</p>
  //     // <p>{moment(startOfMonth).format('MM-DD-YYYY') + " To " + moment(endOfMonth).format('MM-DD-YYYY')}</p>
  //   );

  const customerStatementAPI = () => {
    // let sDate = beginningDate == undefined ? startOfYear : beginningDate;
    // let fDate = finalDate == undefined ? endOfYear : finalDate;
    console.log(beginningDate, finalDate, "checking dates");

    let sDate = beginningDate;
    let fDate = finalDate;
    axios
      .get(
        `${config.customersBaseUrl}/customers/${
          ComponentURl ? "ecomcustomerstatement" : "customerstatement"
        }?customerid=${
          ecomuser ? customerid : paramObject.id
        }&startdate=${sDate}&enddate=${fDate}&Locationid=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setCustomerDetails(res?.data?.ResponseData?.CustomerDetails);
        setCustomerList(res?.data?.ResponseData?.StatementList);
      });
  };

  // useEffect(() => {
  //   customerStatementAPI();
  // }, [selectReport]);
  const fetchSubCompanyLocations = async () => {
    try {
      const response = await axios.get(
        `${config.locationBaseUrl}/locations/getsubcompany`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      const data = response?.data?.ResponseData || [];
      const subCompanyOptions = data
        .filter((item) => item.IsDelete === 0)
        .map((el) => ({
          value: el.ID,
          label: el.Name,
        }));
      setsubCompany(subCompanyOptions);
      // Set default selected where ID === 1 and IsDelete === 0
      const defaultItem = data.find(
        (item) => item.ID === 1 && item.IsDelete == 0
      );
      if (defaultItem) setSelectedSubCompany(defaultItem.Name);
    } catch (error) {
      console.error("Error fetching sub company locations:", error);
    }
  };

  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/CompanyInformation`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })

      .then((res) => {
        setCompanyData(res.data.ResponseData[0]);
      })
      .catch((err) => {
        console.log(err);
      });
    fetchSubCompanyLocations();
  }, []);

  // Print Statement Function-
  // const handlePrint = () => {
  //   var doc = new jsPDF("p", "pt", "a4");

  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `8px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let dateHeaderElement = document.querySelector("#subheader");
  //   let clonedDateHeader = dateHeaderElement.cloneNode(true);
  //   clonedDateHeader.style.fontSize = `8px`;
  //   clonedDateHeader.style.width = "560px";
  //   clonedDateHeader.style.margin = "1rem";
  //   // document.querySelector("#subheader p").style.margin = 0;

  //   let content = "";
  //   let startIndex = 0;
  //   let endIndex = 17;

  //   content += " " + clonedHeader.outerHTML;
  //   content += " " + clonedDateHeader.outerHTML;

  //   // Loop through the customerList array
  //   for (var i = 0; i < Math.ceil(customerList.length / 24); i++) {
  //     if (i > 0) {

  //       clonedDateHeader.style.marginTop = "4rem";
  //       content += " " + clonedDateHeader.outerHTML;
  //     }

  //     // Printing table body-
  //     content +=
  //       '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">S.No.</th>' +
  //       '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Date</th>' +
  //       '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Details</th>' +
  //       '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Amount</th>' +
  //       '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Payments</th>' +
  //       '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Balance</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex-
  //     for (
  //       let index = startIndex;
  //       index < customerList.length && index <= endIndex;
  //       index++
  //     ) {
  //       content +=
  //         "<tr style='border-bottom: 0.5px solid  #f2f2f2; padding-top: 5px'>" +
  //         '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
  //         (index + 1) +
  //         "</td>" +
  //         '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
  //         moment(customerList[index].Date).format("DD/MM/YYYY") +
  //         "</td>" +
  //         '<td style="font-size: 8px; padding: 8px; width: 300px;font-family: Inter, sans-serif;">' +
  //         customerList[index].Details +
  //         "</td>" +
  //         '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
  //         customerList[index].Amount +
  //         "</td>" +
  //         '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
  //         customerList[index].Payments +
  //         "</td>" +
  //         '<td style="font-size: 8px; padding: 8px;font-family: Inter, sans-serif;">' +
  //         customerList[index].Balance +
  //         "</td>" +
  //         "</tr>";
  //     }

  //     content += "</tbody>";
  //     content += "</table>";

  //     // Update startIndex and endIndex for the next iteration
  //     startIndex = endIndex + 1;
  //     endIndex = startIndex + 24;
  //   }

  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.output("dataurlnewwindow");
  //     },
  //   });
  // };

  // const handlePrint = () => {
  //   const printableContainer = document.createElement("div");
  //   printableContainer.style.boxSizing = "border-box";
  //   printableContainer.style.padding = "0";

  //   // Clone and style header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = "10px";
  //   // clonedHeader.style.margin = "0px 5px";
  //   printableContainer.appendChild(clonedHeader);

  //   // Clone and style subheader (only for first page)
  //   let dateHeaderElement = document.querySelector("#subheader");
  //   let clonedDateHeader = dateHeaderElement.cloneNode(true);
  //   clonedDateHeader.style.fontSize = "9px";
  //   // clonedDateHeader.style.margin = "0 5px";
  //   printableContainer.appendChild(clonedDateHeader);

  //   let chunkSize = 28;
  //   let totalPages = Math.ceil(customerList.length / chunkSize);

  //   for (let page = 0; page < totalPages; page++) {
  //     const startIndex = page * chunkSize;
  //     const endIndex = Math.min(startIndex + chunkSize, customerList.length);

  //     // Create a wrapper for each page
  //     const pageContainer = document.createElement("div");
  //     pageContainer.style.breakAfter = "page"; // forces page break after each chunk
  //     pageContainer.style.boxSizing = "border-box";
  //     pageContainer.style.width = "100%";

  //     if (page > 0) {
  //       // Subheader only for pages after first
  //       const repeatedHeader = dateHeaderElement.cloneNode(true);
  //       repeatedHeader.style.fontSize = "9px";
  //       // repeatedHeader.style.margin = "0px";
  //       // repeatedHeader.style.margin = "0 5px 0px 5px";
  //       pageContainer.appendChild(repeatedHeader);
  //     }

  //     // Build table
  //     const table = document.createElement("table");
  //     table.style.fontSize = "7px";
  //     table.style.borderCollapse = "collapse";
  //     table.style.border = "1px solid #f5f5f5";
  //     // table.style.margin = "0px";
  //     table.style.width = "calc(100% - 10px)";

  //     const thead = document.createElement("thead");
  //     thead.innerHTML = `
  //  <tr style="margin-left: 15px; margin-right: 15px;">
  //     <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">S.No.</th>
  //     <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Date</th>
  //     <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Details</th>
  //     <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Amount</th>
  //     <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Payments</th>
  //     <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Balance</th>
  //   </tr>
  // `;
  //     table.appendChild(thead);

  //     const tbody = document.createElement("tbody");
  //     for (let index = startIndex; index < endIndex; index++) {
  //       const row = document.createElement("tr");
  //       row.innerHTML = `
  //     <td style="padding: 4px;">${index + 1}</td>
  //     <td style="padding: 4px;">${moment(customerList[index].Date).format(
  //       dateFormate.toUpperCase()
  //     )}</td>
  //     <td style="padding: 4px; max-width: 300px; word-wrap: break-word;">${
  //       customerList[index].Details
  //     }</td>
  //     <td style="padding: 4px;">${Reportcurrencysymbols(
  //       Number(customerList[index].Amount),
  //       { CurrencySymbol },
  //       FractionDigits,
  //       currencySymbolLocation
  //     )}</td>
  //     <td style="padding: 4px;">${Reportcurrencysymbols(
  //       Number(customerList[index].Payments),
  //       { CurrencySymbol },
  //       FractionDigits,
  //       currencySymbolLocation
  //     )}</td>
  //     <td style="padding: 4px;">${Reportcurrencysymbols(
  //       Number(customerList[index].Balance),
  //       { CurrencySymbol },
  //       FractionDigits,
  //       currencySymbolLocation
  //     )}</td>
  //   `;
  //       tbody.appendChild(row);
  //     }
  //     table.appendChild(tbody);
  //     pageContainer.appendChild(table);

  //     // Page footer
  //     const pageFooter = document.createElement("div");
  //     pageFooter.style.textAlign = "center";
  //     pageFooter.style.fontSize = "10px";
  //     // pageFooter.style.margin = "5px 0 0px";
  //     pageFooter.textContent = `Page ${page + 1} of ${totalPages}`;
  //     pageContainer.appendChild(pageFooter);

  //     printableContainer.appendChild(pageContainer);
  //   }

  //   //   const opt = {
  //   //     margin: 0.0,
  //   //     jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //   //      html2canvas: {
  //   //   scale: 2,
  //   //   // scale: Math.min(3, window.devicePixelRatio || 1), // 2x is usually sharp enough without overloading
  //   //   // useCORS: true,
  //   //   // logging: false,
  //   //   // dpi: 600,
  //   //   // allowTaint: false,
  //   // },
  //   //   };

  //   // If more than 500 records, do not use html2canvas (for performance)
  //   const opt = {
  //     margin: [0, 0.3, 0, 0.3],
  //     jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //     ...(customerList.length > 500
  //     ? {}
  //     : {
  //       html2canvas: {
  //         scale: 3,
  //         logging: true,
  //         useCORS: false,
  //         allowTaint: false,
  //       },
  //       }),
  //     pagebreak: { mode: "css" },
  //   };

  //   html2pdf()
  //     .from(printableContainer)
  //     .set(opt)
  //     // .save()
  //     .output("blob")
  //     .then((pdfBlob) => {
  //       const pdfUrl = URL.createObjectURL(pdfBlob);
  //       window.open(pdfUrl, "_blank");
  //     });
  // };

const handlePrint = () => {
  const printableContainer = document.createElement("div");
  printableContainer.style.boxSizing = "border-box";
  printableContainer.style.padding = "0";

  // Utility to safely clone and style a DOM element
  const cloneStyled = (selector, fontSize) => {
    const el = document.querySelector(selector);
    if (!el) return null;
    const cloned = el.cloneNode(true);
    cloned.style.fontSize = fontSize;
    cloned.style.boxSizing = "border-box";
    cloned.style.margin = "0";
    return cloned;
  };

  // Clone and add header and subheader (only for first page)
  const originalHeader = cloneStyled("#header", "10px");
  const originalSubheader = cloneStyled("#subheader", "9px");

  if (originalHeader) {
    printableContainer.appendChild(originalHeader);
  }

  if (originalSubheader) {
    originalSubheader.style.marginTop = "0"; // no margin for first page
    printableContainer.appendChild(originalSubheader);
  }

  // Setup pagination logic
  const chunks = [];
  if (customerList.length >= 7 && customerList.length <= 14) {
    const firstEnd = Math.min(10, customerList.length);
    chunks.push({ start: 0, end: firstEnd });
    if (firstEnd < customerList.length) {
      chunks.push({ start: firstEnd, end: customerList.length });
    }
  } else {
    const chunkSize = 28;
    for (let i = 0; i < customerList.length; i += chunkSize) {
      chunks.push({ start: i, end: Math.min(i + chunkSize, customerList.length) });
    }
  }

  const totalPages = chunks.length;

  chunks.forEach((chunk, pageIndex) => {
    const pageContainer = document.createElement("div");
    pageContainer.style.breakAfter = "page";
    pageContainer.style.boxSizing = "border-box";
    pageContainer.style.width = "100%";

    // Add subheader only for second page and onward with margin-top: 50px
    if (pageIndex > 0 && originalSubheader) {
      const repeatedSub = originalSubheader.cloneNode(true);
      repeatedSub.style.fontSize = "9px";
      repeatedSub.style.marginTop = "50px";
      pageContainer.appendChild(repeatedSub);
    }

    // Table
    const table = document.createElement("table");
    table.style.fontSize = "7px";
    table.style.borderCollapse = "collapse";
    table.style.border = "1px solid #f5f5f5";
    table.style.width = "calc(100% - 10px)";

    const thead = document.createElement("thead");
    thead.innerHTML = `
      <tr>
        <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">S.No.</th>
        <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Date</th>
        <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Details</th>
        <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Amount</th>
        <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Payments</th>
        <th style="padding: 5px; background-color: #d4d4d4; font-size: 10px;">Balance</th>
      </tr>`;
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    for (let i = chunk.start; i < chunk.end; i++) {
      const item = customerList[i];
      const row = document.createElement("tr");
      row.innerHTML = `
        <td style="padding: 4px;">${i + 1}</td>
        <td style="padding: 4px;">${moment(item.Date).format(dateFormate.toUpperCase())}</td>
        <td style="padding: 4px; max-width: 300px; word-wrap: break-word;">${item.Details || ""}</td>
        <td style="padding: 4px;">${Reportcurrencysymbols(
          Number(item.Amount),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        )}</td>
        <td style="padding: 4px;">${Reportcurrencysymbols(
          Number(item.Payments),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        )}</td>
        <td style="padding: 4px;">${Reportcurrencysymbols(
          Number(item.Balance),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        )}</td>`;
      tbody.appendChild(row);
    }
    table.appendChild(tbody);
    pageContainer.appendChild(table);

    // Page footer
    const pageFooter = document.createElement("div");
    pageFooter.style.textAlign = "center";
    pageFooter.style.fontSize = "10px";
    pageFooter.textContent = `Page ${pageIndex + 1} of ${totalPages}`;
    pageContainer.appendChild(pageFooter);

    printableContainer.appendChild(pageContainer);
  });

  // html2pdf options
  const opt = {
    margin: [0, 0.3, 0, 0.3],
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    pagebreak: { mode: "css" },
  };

  if (customerList.length <= 500) {
    opt.html2canvas = {
      scale: 3,
      logging: true,
      useCORS: false,
      allowTaint: false,
    };
  }

  html2pdf()
    .from(printableContainer)
    .set(opt)
    .output("blob")
    .then((pdfBlob) => {
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    });
};



  // const handlePrint1 = () => {
  //   if (!jsPDF || !jsPDF.API || !jsPDF.API.autoTable) {
  //     console.error("jsPDF or autoTable not loaded");
  //     return;
  //   }

  //   const doc = new jsPDF({
  //     unit: "pt",
  //     format: "a4",
  //     orientation: "portrait",
  //   });

  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   const margin = 40;

  //   // Header info
  //   const companyName = SelectedSubCompany || "";
  //   const companyAddress = companyData?.CompanyAddress || "";
  //   const website = companyData?.Website || "";

  //   // Draw header
  //   doc.setFont("Helvetica");
  //   doc.setFontSize(22);
  //   doc.text(companyName, margin, 50);

  //   doc.setFontSize(10);
  //   doc.text(companyAddress, margin, 70);
  //   doc.text(website, margin, 85);

  //   doc.setFontSize(28);
  //   doc.text("Statement", margin, 120);

  //   // Recipient (TO) block
  //   const toYStart = 140;
  //   doc.setFont(undefined, "bold");
  //   doc.setFontSize(10);
  //   doc.text("TO", margin, toYStart);
  //   doc.setFont(undefined, "normal");

  //   let currY = toYStart + 15;
  //   doc.text(
  //     `${firstCustomer.FirstName || ""} ${firstCustomer.LastName || ""}`.trim(),
  //     margin,
  //     currY
  //   );
  //   currY += 14;
  //   doc.text(`${firstCustomer.Companyname || "Your Company Name"}`, margin, currY);
  //   currY += 14;
  //   doc.text(
  //     `${firstCustomer.Address1 || ""} ${firstCustomer.Address2 || ""}`.trim(),
  //     margin,
  //     currY
  //   );
  //   currY += 14;
  //   doc.text(
  //     `${firstCustomer.City || ""}, ${firstCustomer.State || ""} ${firstCustomer.Zip || ""}, ${
  //       firstCustomer.Country || ""
  //     }`.trim(),
  //     margin,
  //     currY
  //   );
  //   currY += 14;
  //   doc.text(`${firstCustomer.Email || ""}`, margin, currY);

  //   // Statement info (right side)
  //   const rightX = pageWidth - margin - 220;
  //   let infoY = toYStart;
  //   doc.setFont(undefined, "bold");
  //   doc.text("STATEMENT DATE:", rightX, infoY);
  //   doc.setFont(undefined, "normal");
  //   doc.text(formattedStatementDate, rightX + 120, infoY);

  //   infoY += 16;
  //   doc.setFont(undefined, "bold");
  //   doc.text("CREATED DATE:", rightX, infoY);
  //   doc.setFont(undefined, "normal");
  //   doc.text(createdDate, rightX + 120, infoY);

  //   infoY += 16;
  //   doc.setFont(undefined, "bold");
  //   doc.text("TOTAL DUE:", rightX, infoY);
  //   doc.setFont(undefined, "normal");
  //   doc.text(formattedTotalDue, rightX + 120, infoY);

  //   // Divider
  //   doc.setDrawColor(200);
  //   doc.setLineWidth(0.5);
  //   doc.line(margin, 170, pageWidth - margin, 170);

  //   // Table body data
  //   const body = (customerList || []).map((item, idx) => [
  //     idx + 1,
  //     moment(item.Date).format("DD/MM/YYYY"),
  //     item.Details || "",
  //     CurrencySymbols(Number(item.Amount || 0), { CurrencySymbol }, FractionDigits),
  //     CurrencySymbols(Number(item.Payments || 0), { CurrencySymbol }, FractionDigits),
  //     CurrencySymbols(Number(item.Balance || 0), { CurrencySymbol }, FractionDigits),
  //   ]);

  //   // Render table with autoTable
  //   doc.autoTable({
  //     startY: 180,
  //     head: [["S.No.", "Date", "Details", "Amount", "Payments", "Balance"]],
  //     body,
  //     styles: {
  //       fontSize: 8,
  //       cellPadding: 4,
  //       overflow: "linebreak",
  //     },
  //     headStyles: {
  //       fillColor: [212, 212, 212],
  //       textColor: 0,
  //       fontSize: 10,
  //       halign: "left",
  //     },
  //     columnStyles: {
  //       0: { cellWidth: 40, halign: "left" },
  //       1: { cellWidth: 70, halign: "left" },
  //       2: { cellWidth: 220, halign: "left" },
  //       3: { halign: "right" },
  //       4: { halign: "right" },
  //       5: { halign: "right" },
  //     },
  //     margin: { left: margin, right: margin },
  //     theme: "grid",
  //     showHead: "everyPage",
  //     didDrawPage: () => {
  //       const pageNum = doc.getCurrentPageInfo().pageNumber;
  //       const pageCount = doc.getNumberOfPages();
  //       doc.setFontSize(10);
  //       doc.text(
  //         `Page ${pageNum} of ${pageCount}`,
  //         pageWidth / 2,
  //         pageHeight - 30,
  //         { align: "center" }
  //       );
  //     },
  //   });

  //   // Open PDF
  //   const pdfBlob = doc.output("blob");
  //   const pdfUrl = URL.createObjectURL(pdfBlob);
  //   window.open(pdfUrl, "_blank");
  // };

  // Send Mail Function-
  const handleMailPdf = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";
    clonedHeader.style.marginTop = "20px";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 18;
    let counter = 0;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(customerList.length / 27); i++) {
      if (i >= 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "4rem";
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Sr No.</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Date</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif width: 300px">Details</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Amount</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Payments</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < customerList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          moment(customerList[index].Date).format("MM/DD/YYYY ") +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px; width: 300px">' +
          customerList[index].Details +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          customerList[index].Amount +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          customerList[index].Payments +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;">' +
          customerList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 26;
    }

    doc.html(content, {
      callback: function (pdf) {
        const pdfBlob = pdf.output("blob");

        // Create a data URL from the PDF Blob
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Prepare the email subject and body
        const emailSubject = encodeURIComponent("");
        const emailBody = encodeURIComponent("");

        // Create the mailto link with the PDF data URL as attachment
        const mailtoLink = `mailto:?subject=${emailSubject}&body=${emailBody}&attachment=${pdfDataUrl}`;

        // Open the default email client (Gmail) with the mailto link
        window.location.href = mailtoLink;
      },
    });
  };

  //  return
  return (
    <div className={"col-lg-12 col-md-12"}>
      <div className="card bg-white" style={{ borderRadius: "10px" }}>
        <div style={{ fontWeight: "300", margin: "10px 0 0 10px" }}>
          <h4 className="card-title">Customer Statement</h4>
        </div>
        <hr style={{ color: "#cfcfcf" }} />
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            // marginTop: "20px",
          }}
        >
          <div style={{ width: "20%", marginLeft: "20px" }}>
            <label className="col-form-label col-md-12 form-label p-lg-medium">
              Date Filter:{" "}
            </label>
            <Select
              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
              options={reportdropdown}
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              hideSelectedOptions={true}
              // isClearable={true}
              name="Reportperiod"
              id="Reportperiod"
              value={reportdropdown.find((e) => e.value === selectReport)}
              onChange={(event) => {
                handleDropdownChange(event);
              }}
              className="custom-search-select"
            ></Select>
          </div>
          {selectReport !== 1 && (
            <div className="col-sm-4">
              {/* <div className="row"> */}
              <ReportDate
                callback={callback}
                selectReport={selectReport}
                showhidecomponent={
                  selectReport == 2 ||
                  selectReport == 3 ||
                  selectReport == 4 ||
                  selectReport == 5 ||
                  selectReport == 6 ||
                  selectReport == 7 ||
                  selectReport == 8 ||
                  selectReport == 9 ||
                  selectReport == 10 ||
                  selectReport == 11 ||
                  selectReport == 12 ||
                  selectReport == 13 ||
                  selectReport == 14 ||
                  selectReport == 15 ||
                  selectReport == 16 ||
                  selectReport == 17 ||
                  selectReport == 18 ||
                  selectReport == 19 ||
                  selectReport == 20 ||
                  selectReport == 21 ||
                  selectReport == 22 ||
                  selectReport == 23 ||
                  selectReport == 24 ||
                  selectReport == 25 ||
                  selectReport == 26 ||
                  selectReport == 27 ||
                  selectReport == 28 ||
                  selectReport == 29 ||
                  selectReport == 30 ||
                  selectReport == 31
                    ? true
                    : false
                }
              />
              {/* </div> */}
            </div>
          )}
          {selectReport === 2 && (
            <div>
              {/* <div style={{ width: "20%", marginTop: "3px" }}>
                Start Date:-
                <CommonDatePicker
                  FinalDate={startDate}
                  handleDateChange={handleDate}
                />
              </div>
              <div style={{ width: "20%", marginTop: "3px" }}>
                End Date:-
                <CommonDatePicker
                  FinalDate={endDate}
                  handleDateChange={handleEndDate}
                />
              </div> */}
              <label className="col-form-label form-label p-lg-medium"> </label>
              <button
                className="btn btn-primary "
                style={{
                  height: "fit-content",
                  marginTop: "30px",
                }}
                onClick={(e) => handleSearch(e)}
              >
                Search
              </button>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginRight: "20px",
              gap: "10px",
            }}
          >
            {" "}
            <Select
              options={subCompany}
              value={subCompany.find((el) => el.label === SelectedSubCompany)}
              onChange={(e) => setSelectedSubCompany(e?.label || "")}
              // isClearable={true}
              placeholder="Select Sub Company"
              // className="w-100"
              styles={CUSTOM_SELECT_DROPDOWN_RECEIPT_STYLE}
            />
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-print" onClick={handlePrint} />
            </div>
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-envelope" onClick={handleMailPdf} />
            </div>
          </div>
        </div>

        {/* Print Statememt */}
        <div className="card-body" id="print">
          <div
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "20px",
              borderRadius: "10px",
              fontFamily: "Inter",
            }}
          >
            {/* Header */}
            {/* <div id="header">
              <div className="text-right">
                {customerDetails?.map((el) => {
                  return (
                    <>
                      <p
                        className="h-tag"
                        style={{
                          fontWeight: "bold",
                          margin: "0",
                          fontFamily: "Inter, sans-serif",
                        }}
                      >
                        {el?.Companyname}
                      </p>
                      <span style={{ fontFamily: "Inter, sans-serif" }}>
                        {el?.Address1 + " " + el?.Address2}
                      </span>
                      <br />
                      <span style={{ fontFamily: "Inter, sans-serif" }}>
                        {el.City &&
                          el.State &&
                          el.Country &&
                          el?.Zip &&
                          el.City +
                            ", " +
                            el.State +
                            " " +
                            el?.Zip +
                            ", " +
                            el.Country}
                      </span>

                      <br />

                    </>
                  );
                })}
              </div>
              <hr style={{ color: "#cfcfcf" }} />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {customerDetails?.map((el) => {
                  return (
                    <div
                      style={{
                        width: "22%",
                        display: "flex",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      <div>
                        <strong>To: </strong>
                        {el?.FirstName + " " + el?.LastName}
                      </div>
                    </div>
                  );
                })}
                <div className="text-right">
                  <strong>Account Summary</strong>
                  {beginningDate === "" && finalDate === ""
                          ? "All Data"
                          : moment(beginningDate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(finalDate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                </div>
              </div>
              <hr
                style={{ width: "20%", marginLeft: "auto", color: "#cfcfcf" }}
              />
              <div>
                {customerDetails?.map((el) => {
                  return (
                    <>
                      <div>
                        <span className="text-left">
                          <strong> Opening Balance: </strong>
                          {CurrencySymbols(
                            Number(el?.BeginningBalance),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                          </span>
                        <span className="text-left">
                          <strong> | Invoiced Amount: </strong>
                          {CurrencySymbols(
                            Number(el?.InvoicedAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                    
                        </span>
                        <span className="text-left">
                          <strong> | Journal Debits:</strong>
                          {CurrencySymbols(
                            Number(el?.JournalDebitsAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
             
                        </span>
                        <span className="text-left">
                          <strong> | Expense: </strong>
                          {CurrencySymbols(
                            Number(el?.ExpenseAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                        </span>
                        <span className="text-left">
                          <strong> | Check: </strong>
                          {CurrencySymbols(
                            isNaN(Number(el?.CheckAmount))
                              ? 0
                              : Number(el?.CheckAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                        </span>
                        <span className="text-left">
                          <strong> | Amount Paid:</strong>
                          {CurrencySymbols(
                            Number(el?.AmountPaid),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                        </span>
                        <span className="text-left">
                          <strong> | Credit Memo: </strong>
                          {CurrencySymbols(
                            isNaN(Number(el?.CreditAppliedAmount))
                              ? 0
                              : Number(el?.CreditAppliedAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                   
                        </span>
                        <span className="text-left">
                          <strong> | Journal Credits: </strong>
                          {CurrencySymbols(
                            Number(el?.JournalCreditsAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                        </span>
                        <span className="text-left">
                          <strong> | Deposit: </strong>
                          {CurrencySymbols(
                            Number(el?.DepositAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                        </span>
                        <span className="text-left">
                          <strong> | CC Credit: </strong>
                          {CurrencySymbols(
                            isNaN(Number(el?.CcCreditAmount))
                              ? 0
                              : Number(el?.CcCreditAmount),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                        </span>

                      </div>
                      <div></div>
                      <hr
                        style={{
                          width: "20%",
                          color: "#cfcfcf",
                        }}
                      />

                      <div className="text-left">
                        <strong>Balance Due: </strong>
                        {CurrencySymbols(
                          Number(el?.BalanceDue),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </div>
                    </>
                  );
                })}
              </div>
            </div> */}

            {/* Header */}
            <div id="header" style={{ fontFamily: "Inter" }}>
              <span class="fs-2">{SelectedSubCompany}</span>
              <br />
              <span>{companyData?.CompanyAddress}</span>
              <br />
              <span>{companyData?.Website}</span>
              <hr style={{ color: "#cfcfcf" }} />
            </div>

            {/* SubHeader */}
            <div
              id="subheader"
              style={{
                fontFamily: "Inter",
                marginTop: "50px",
              }}
              // className='ml-5 mr-5'
            >
              <h5>Statement</h5>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {/* Left: Sender Info */}
                <div>
                  <strong>TO</strong>
                  <div>
                    <div>
                      {customerDetails[0]?.FirstName}{" "}
                      {customerDetails[0]?.LastName}
                    </div>
                    <p>
                      {customerDetails[0]?.Companyname || "Your Company Name"}
                    </p>
                    <span>
                      {customerDetails[0]?.Address1}{" "}
                      {customerDetails[0]?.Address2}
                    </span>
                    <br />
                    <span>
                      {customerDetails[0]?.City}, {customerDetails[0]?.State}{" "}
                      {customerDetails[0]?.Zip}, {customerDetails[0]?.Country}
                    </span>
                    <br />
                    <span>{customerDetails[0]?.Email}</span>
                  </div>
                </div>

                {/* Right: Statement Info */}
                <div
                  style={{
                    textAlign: "right",
                    fontFamily: "Inter",
                  }}
                >
                  <span>
                    <strong>STATEMENT DATE:</strong>{" "}
                    <span>
                      <strong>
                        {beginningDate === "" && finalDate === ""
                          ? "All Data"
                          : moment(beginningDate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(finalDate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </strong>
                    </span>
                  </span>
                  <div>
                    <strong>CREATED DATE:</strong>{" "}
                    {moment().format("MM/DD/YYYY")}
                  </div>
                  <div>
                    <strong>TOTAL DUE:</strong>{" "}
                    {CurrencySymbols(
                      Number(customerDetails[0]?.BalanceDue || 0),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </div>
                </div>
              </div>
              <hr style={{ color: "#cfcfcf" }} />
            </div>

            {/* Date Header */}
            {/* <div
              id="date-header"
              style={{ textAlign: "center", margin: "20px 0 20px 0" }}
            >
              <p>
                              Showing all Invoices and payments between                
                            </p>
                            <p><strong>{beginningDate === "" && finalDate === ""
                                                        ? "All Data"
                                                        : moment(beginningDate).format(
                                                            `${dateFormate.toUpperCase()}`
                                                          ) +
                                                          " - " +
                                                          moment(finalDate).format(
                                                            `${dateFormate.toUpperCase()}`
                                                          )}</strong></p>
            </div> */}

            {/* Table Body */}
            <div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={customerList}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  sortServer
                  dense
                />
              </div>
              <div
                style={{
                  textAlign: "right",
                  marginTop: "2rem",
                }}
              >
                {customerDetails?.map((el) => (
                  <p style={{ margin: "1rem" }}>
                    <strong>Balance Due </strong>{" "}
                    <span style={{ marginLeft: "2rem" }}>
                      {CurrencySymbols(
                        Number(el.BalanceDue),
                        { CurrencySymbol },
                        FractionDigits
                      )}
                      {/* {`$${Number(el?.BalanceDue).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
                      {/* ${el?.BalanceDue} */}
                    </span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseStatement;
